import { Film, Mountain, Wine, Shield, Car, Headphones } from 'lucide-react';
import { features } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = { Film, Mountain, Wine, Shield, Car, Headphones };

export const Features = () => {
  const [ref, isInView] = useInView();

  return (
    <section className="section-gap bg-obsidian-light relative overflow-hidden dot-pattern">
      <div ref={ref} className="relative max-w-6xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-20 transition-all duration-900 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
          }>

          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-8 h-px bg-amber/20" />
            <span className="font-body text-[11px] tracking-[0.4em] uppercase text-amber/50">
              What Awaits You
            </span>
            <div className="w-8 h-px bg-amber/20" />
          </div>
          <h2 className="font-heading text-[2.5rem] md:text-[3.5rem] font-light text-ivory">
            Every Detail, <em className="italic text-amber">Curated</em>
          </h2>
        </div>

        {/* Features - 2 column layout for more space */}
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-10 lg:gap-x-20 lg:gap-y-14">
          {features.map((feature, index) => {
            const IconComp = iconMap[feature.icon];
            return (
              <div
                key={index}
                className={`group flex items-start gap-6 transition-all duration-700 ${
                isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`
                }
                style={{ transitionDelay: isInView ? `${index * 100 + 200}ms` : '0ms' }}>

                <div className="shrink-0 w-12 h-12 rounded-sm border border-amber/[0.08] flex items-center justify-center group-hover:border-amber/20 transition-colors duration-400">
                  {IconComp && <IconComp size={18} className="text-amber/60" />}
                </div>
                <div>
                  <h3 className="font-heading !font-medium !text-xl mb-1.5 text-ivory/85">
                    {feature.title}
                  </h3>
                  <p className="font-body !font-light text-[14px] text-ivory/30">
                    {feature.description}
                  </p>
                </div>
              </div>);

          })}
        </div>
      </div>
    </section>);

};